export enum OptionType {
  OPP_CALC = 'opp_calc',
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  TEMPLATE = 'template',
}
